import clsx from 'clsx'
import Image from 'next/image'

/* blocks */
import Link from '@/atoms/Link/Link'

/* styling */
import styles from './_.module.css'

interface Props {
  title: string
  list: StrapiSpeakerDetailsCardComponent[]
}

function PeopleSpeaking({ title, list }: Props) {
  return (
    <section
      id="people-speaking"
      className={clsx(
        'bg-[#090909] text-white relative',
        list.length === 0 ? 'h-screen w-screen' : ''
      )}
    >
      <div>
        {list.length === 0 ? (
          <Image
            src="/assets/index-25/decode-bg-img.png"
            alt="decode-bg-img"
            height="955"
            width="1441"
            className="absolute w-full h-full object-top"
          />
        ) : null}

        {list.length === 0 ? (
          <div className="container | absolute inset-0 flex flex-col items-center justify-center gap-7 z-10 mx-auto py-10 md:py-18">
            <div className="md:flex md:justify-center md:items-center md:gap-4 | mb-10">
              <h1 className="title text-3xl md:text-5xl font-medium tracking-tight">
                {title}
              </h1>
            </div>
            <div className="flex flex-col justify-center items-center gap-4 | mb-10">
              <h2 className="text-4xl md:text-6xl font-bold tracking-tight mb-6">
                COMING SOON
              </h2>
              <p className="text-2xl md:text-4xl font-medium text-[#E8E8E8]">
                Stay Tuned
              </p>
            </div>
          </div>
        ) : (
          <>
            <div className="container | py-10 md:py-18">
              <div className="flex flex-wrap items-center gap-4 | mb-14 md:mb-20 md:max-w-col-9">
                <h1 className="title text-4xl md:text-6xl font-medium tracking-tight">
                  {title}
                </h1>
              </div>
              <div className="relative | mb-14">
                <div
                  className={clsx(
                    'grid grid-cols-2 md:grid-cols-5 gap-7 relative | pr-2 md:pr-18 max-h-[738px] md:max-h-[1049px] overflow-y-scroll snap-y snap-mandatory',
                    styles.scrollbar
                  )}
                >
                  {list.map(influencer => {
                    return (
                      <div key={influencer.id}>
                        <article key={influencer.name}>
                          <div className="font-heading | rounded-lg | max-w-col-6 mx-auto">
                            {influencer?.image.data?.attributes.url ? (
                              <Image
                                src={influencer.image.data.attributes.url}
                                alt={
                                  influencer.image.data.attributes
                                    .alternativeText ?? ''
                                }
                                width={influencer.image.data.attributes.width}
                                height={influencer.image.data.attributes.height}
                                className="object-cover | border | mb-5 md:mb-7 mx-auto"
                              />
                            ) : null}
                            <div className="text-center | max-w-col-3 mx-auto">
                              <h3
                                className="text-base md:text-2xl font-bold | mb-2"
                                dangerouslySetInnerHTML={{
                                  __html: influencer.name
                                }}
                              />
                              <div className="flex flex-col flex-wrap justify-center">
                                <span
                                  className={clsx(
                                    'text-xs md:text-sm | mb-2 md:mb-3',
                                    styles.designation
                                  )}
                                  dangerouslySetInnerHTML={{
                                    __html: influencer.description
                                  }}
                                />
                                {influencer.companyImage.data[0].attributes
                                  .url && (
                                  <Image
                                    src={
                                      influencer.companyImage.data[0].attributes
                                        .url
                                    }
                                    width={
                                      influencer.companyImage.data[0].attributes
                                        .width
                                    }
                                    height={
                                      influencer.companyImage.data[0].attributes
                                        .height
                                    }
                                    alt={
                                      influencer.companyImage.data[0].attributes
                                        .alternativeText ?? ''
                                    }
                                    className="w-14 h-7 md:w-20 md:h-9 mx-auto"
                                  />
                                )}
                              </div>
                            </div>
                          </div>
                        </article>
                      </div>
                    )
                  })}
                </div>
              </div>
              <div className="flex flex-col md:flex-row justify-center">
                <Link
                  className="bg-linear-to-r from-[#1600E5] to-[#4B77F2] flex justify-center items-center gap-2 flex-nowrap text-sm font-medium rounded-lg py-2 px-10 w-full md:w-auto"
                  href={'#invite-only'}
                >
                  Register Now
                </Link>
              </div>
            </div>
          </>
        )}
      </div>
    </section>
  )
}

export default PeopleSpeaking
